export default __webpack_public_path__ + "static/media/dollar.9fd1c3e5.svg";